import { IVenueOpeningTimesRequest } from 'src/api/createVenueOpeningTimes/types';
import { IOpeningTime, TOpeningTimes } from 'src/types/venueForm.types';

const formatOpeningTimesPayload = (data: TOpeningTimes): IVenueOpeningTimesRequest => {
  const days = Object.keys(data);
  const openingTimes = [];
  days.forEach((day: string) => {
    data[day].map((time: IOpeningTime) => {
      if (!time.openingTimeId && time.end && time.start)
        return openingTimes.push({ start_time: time.start, end_time: time.end, day_of_week: day });
    });
  });

  return { schedules: openingTimes };
};

export default formatOpeningTimesPayload;
